import * as React from 'react';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { fontFamilies } from '../../theme/text';

const CssTextField = withStyles({
  root: {
    '& .MuiFormControl': {
      '&$root': {
        width: '100%',
        height: '100%'
      }
    },
    '& label.Mui-focused': {
      color: '#4F4F4F'
    },
    '& .MuiOutlinedInput-root': {
      height: 98,
      width: 600,
      fontFamily: fontFamilies.body,
      fontSize: 14,
      letterSpacing: '0.3px',
      color: 'black',
      fontWeight: 300,
      '&.Mui-focused fieldset': {
        borderColor: '#00AAFC'
      }
    },
    '& .MuiOutlinedInput-input': {
      height: '100% !important'
    }
  }
})(TextField);

const Textbox = (props: TextFieldProps) => {
  return <CssTextField {...props} InputLabelProps={{ shrink: true }} />;
};

export default Textbox;
